import gql from 'graphql-tag';

import { PhotoThumbnails } from '../../../graphql/fragments/album';

export const AccountFileCommentForNotification = gql`
  query accountFileCommentForNotification($id: RecordID!) {
    accountFileComment(id: $id) {
      id
      parent {
        id
      }
      account {
        id
        username
        name
      }
      photo {
        id
        is_owner
        is_uploader
        ...PhotoThumbnails
        albums(slice: { limit: 1 }) {
          records {
            id
            album_type
            album_subtype
            creator {
              id
            }
          }
        }
      }
      video {
        id
        name
        embed_url
        video_provider
        video_links {
          records {
            __typename
            ... on VideoAlbumFolderLink {
              id
              link_type
              album_folder {
                id
                album_type
                album_subtype
                is_root
              }
            }

            ... on VideoAlbumLink {
              id
              link_type
              album {
                id
                album_type
                album_subtype
                is_video_album
              }
            }
          }
        }
      }
    }
  }
  ${PhotoThumbnails}
`;
